import Link from "next/link";
import { env } from "~/env.mjs";
import { classNames } from "~/utils/";

export interface Props {
  currentTab: string;
  groups: {
    label: string;
    title: string;
    href: string;
    isExperimental: boolean;
    description?: React.ReactNode;
  }[];
}

const ButtonGroup: React.FC<Props> = ({ currentTab, groups }: Props) => {
  return (
    <div className="relative z-0 grid grid-cols-4 justify-center gap-1 rounded-lg shadow-sm md:inline-flex md:flex-wrap md:gap-0 md:bg-dark-400">
      {groups.map((group, index) => {
        return (
          <>
            {group.isExperimental && env.NEXT_PUBLIC_EXPERIMENTAL && (
              <Link
                key={`header-pill-${index}`}
                href={group.href}
                type="button"
                className={classNames(
                  currentTab === group.label
                    ? "z-10 bg-primary-100  ring-primary-100 "
                    : "bg-dark-400 ",
                  "relative inline-flex items-center justify-center rounded-lg px-1 py-2 text-center text-[0.6rem] font-semibold  text-light-100 hover:bg-dark-50 md:px-4 md:text-sm md:font-bold"
                )}
              >
                {group.title}
              </Link>
            )}
            {!group.isExperimental && (
              <Link
                key={`header-pill-${index}`}
                href={group.href}
                type="button"
                className={classNames(
                  currentTab === group.label
                    ? "z-10 bg-primary-100  ring-primary-100 "
                    : "bg-dark-400 ",
                  "relative inline-flex items-center justify-center rounded-lg px-1 py-2 text-center text-[0.6rem] font-semibold  text-light-100 hover:bg-dark-50 md:px-4 md:text-sm md:font-bold"
                )}
              >
                {group.title}
              </Link>
            )}
          </>
        );
      })}
    </div>
  );
};

export default ButtonGroup;
